import { getProductImage } from '@/utils/productUtils';

const buildLinkedData = (
  url,
  products,
  isMobile = false
) => {
  const json = {
    '@context': 'https://schema.org',
    '@type': 'ItemList',
    itemListElement: [],
  };
  if (products) {
    const imgSize = isMobile ? 'mobile' : 'thumb';
    json.itemListElement = products.map(
      ({ productName, seoKeyword, image, longdesc, isSpirit }, key) => ({
        '@type': 'ListItem',
        position: key,
        name: productName,
        image: getProductImage(image, false, imgSize),
        url: `${url}/${isSpirit ? 'spirits/' : '' }${seoKeyword}`,
        description: longdesc,
      })
    );
  }

  return json;
};

export default buildLinkedData;
